export function isNotEmptyObject(obj: any) {
  return obj !== null && typeof obj === 'object' && Object.keys(obj).length > 0;
}